import * as React from 'react';
import { Switch, } from 'react-router-dom';
import routes from './router';

class Service extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  render() {
    return (
      <React.Fragment>
        <Switch>
          {routes}
        </Switch>
      </React.Fragment >
    );
  }
}

export default Service;
